import { MasterConfigs } from "../../../../interfaces/entity";

export const WallConfig: MasterConfigs = {
    api: () => '/wall',
    title: 'Wall',
    isActionTab: true,
    modalTitle: (action) => `${action} ${WallConfig.title}`,
    getFormColumns: () => {
        return [
            {
                label: 'Department wall',
                name: 'departmentWall',
                type: 'checkboxGroup',
                span: 24,
                children: [
                    {
                        name: 'Enable department wall',
                        value: 'enableDepartmentWall'
                    }
                ]
            },
            {
                label: 'Organization Wall Settings',
                name: 'organizationWall',
                type: 'checkboxGroup',
                span: 24,
                children: [
                    {
                        name: 'Employees can post content in organization view',
                        value: 'enableOrganizationWall'
                    }, {
                        name: 'Employees can post poll in organization view',
                        value: 'enableOrganizationPoll'
                    },
                    {
                        name: 'Employees can post announcement in organization view',
                        value: 'enableOrganizationAnnouncement'
                    }
                ]
            },
            {
                label: 'Organization and Department Wall Settings',
                name: 'organizationAndDepartmentWall',
                type: 'checkboxGroup',
                span: 24,
                children: [
                    {
                        name: 'Hide birthday wizard in both org and department wall',
                        value: 'hideBirthdayWizard'
                    }
                ]
            }
        ];
    },
    combo: [],
    getData: () => ({}),
    actions: [],
};
